import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLanguage, detectLanguage } from './language';
import csCommon from './locales/cs/common.json';
import enCommon from './locales/en/common.json';
import skCommon from './locales/sk/common.json';

export const defaultNS = 'common';

/**
 * Every translation, bundled rather than fetched. Three languages of a few hundred short strings is
 * a handful of kilobytes — small enough that splitting them would buy nothing and cost a loading
 * state on the very first paint.
 */
export const resources = {
  en: { common: enCommon },
  cs: { common: csCommon },
  sk: { common: skCommon },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: defaultLanguage,
  defaultNS,

  // React escapes what it renders; leaving this on would turn every apostrophe into an entity.
  interpolation: { escapeValue: false },

  // Resources are already in memory, so initialization is synchronous and nothing ever suspends —
  // without these two, the first render can flash raw keys.
  initImmediate: false,
  react: { useSuspense: false },
});

export default i18n;
